import React from 'react';
import block from 'bem-cn';

import Button from 'components/Button';
import SVG from 'components/SVG';

import { PAYMENT_RESULT, formatElapsed } from 'features/finance/data';

import errorSVG from './img/error.svg';

import './ResultStep.scss';

const b = block('payments-result');

const ResultStep = ({ status, elapsedSeconds, locale, onRestart }) => {
  const isSuccess = status === PAYMENT_RESULT.SUCCESS;

  return (
    <div className={b()}>
      <h1 className={b('title')}>{locale.balancePurchase}</h1>

      {isSuccess ? (
        <>
          <p className={b('headline')}>{locale.paymentSuccess}</p>
          <p className={b('message')}>
            {locale.fundsCredited}
            <br />
            {locale.youMayClosePage}
          </p>
          <div className={b('elapsed')}>
            <span>{locale.elapsedTime}</span>
            <span>{formatElapsed(elapsedSeconds)}</span>
          </div>
        </>
      ) : (
        <>
          <div className={b('error-icon')}>
            <SVG svgProps={{ svg: errorSVG }} />
          </div>
          <p className={b('fail-text')}>{locale.failedToTopUp}</p>
        </>
      )}

      <Button
        type="button"
        text={isSuccess ? locale.topUpMore : locale.topUpAgain}
        size="high"
        upperCased
        callBack={onRestart}
      />
    </div>
  );
};

export default ResultStep;
